import styled from 'styled-components'

export const CustomTableContainer = styled.div`
    &.affiliated-list {
        max-height: 268px;
        min-height: 268px;
        overflow: auto;
    }
    div {
        margin-bottom: 20px;
    }
    &.resource-list{
        width: 100%;
    }
    .custom-list-resource-list {
        table-layout: fixed;
        
        td {
            word-wrap: break-word;
        }
        th {
            word-wrap: break-word;
        }
        .custom-list-column-productAdded {
            width: 150px;
        }
    }
`

export const CustomTable = styled.table`
    position: relative;
    width: calc(100%);

    &,
    td,
    th {
        border-bottom: 1px solid var(--gray-400);
        text-align: left;
    }

    thead tr th {
        color: var(--gray-700);
        font-family: var(--font-bold);
        font-size: 12px;
        padding: 8px;
        white-space: nowrap;
    }

    /* tbody  */

    tbody {
        tr {
            td {
                color: var(--gray-800);
                padding: 16px 8px;
            }

            .custom-list-column-actions {
                white-space: nowrap;
                opacity: 0;
                text-align: right;
            }

            &:hover {
                background-color: var(--blue-200);

                .custom-list-column-actions {
                    opacity: 1;
                }
            }
        }

        i {
            color: var(--blue-500);
            font-size: 16px;
            cursor: pointer;

            &:not(:last-child) {
                margin-right: 6px;
            }

            &.fa-trash-alt {
                color: var(--red-700);
            }
        }
    }

    .types {
        display: flex;
        flex-direction: column;
        margin: 0;

        span + span {
            margin-top: 5px;
        }
    }

    .users {
        display: flex;
        flex-direction: column;
        margin: 0;

        span + span {
            margin-top: 5px;
        }
    }

    &.custom-list-affiliated-list {
        thead {
            background: var(--gray-200);

            .custom-list-column-avatar {
                padding: 8px 8px 8px 20px;
            }
            .custom-list-column-responsible {
                padding: 8px 20px 8px 8px;
            }
        }
        tbody {
            .custom-list-column-avatar {
                padding: 8px 8px 8px 20px;
            }
            .custom-list-column-responsible {
                padding: 8px 20px 8px 8px;
            }
        }
    }
    .custom-list-column-productAdded {
        ul {
            margin: 0;
        }
    }
    .custom-list-column-affiliatedTo {
        div {
            margin: 0;
        }
    }
`
